export const ComponentSubtypes = {
  ARM: 'arm',
  AUDIO_IN: 'audio_in',
  AUDIO_OUT: 'audio_out',
  BASE: 'base',
  BOARD: 'board',
  BUTTON: 'button',
  CAMERA: 'camera',
  ENCODER: 'encoder',
  GANTRY: 'gantry',
  GENERIC: 'generic',
  GRIPPER: 'gripper',
  INPUT_CONTROLLER: 'input_controller',
  MOTOR: 'motor',
  MOVEMENT_SENSOR: 'movement_sensor',
  POSE_TRACKER: 'pose_tracker',
  POWER_SENSOR: 'power_sensor',
  SERVO: 'servo',
  SENSOR: 'sensor',
  SWITCH: 'switch',
} as const;

export type ComponentSubtype =
  (typeof ComponentSubtypes)[keyof typeof ComponentSubtypes];

const componentSubtypeValues: ReadonlySet<string> = new Set(
  Object.values(ComponentSubtypes)
);

export const isComponentSubtype = (name: string): name is ComponentSubtype => {
  return componentSubtypeValues.has(name);
};
